export enum CUSTOMER_SETTINGS {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=9585136
     */
    ADVANCED_SETTINGS = 'ADMIN.INSTANCE.ADVANCED_SETTINGS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=56842384
     */
    BROWSER_TRANSLATION = 'BROWSER_TRANSLATION',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452425
     */
    AVAILABLE_LANGS = 'AVAILABLE_LANGS',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452940
     */
    FALLBACK_LANGS = 'FALLBACK_LANGS',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452515
     */
    COMMUNITY_FILTERS = 'COMMUNITY_FILTERS',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452665
     */
    CONTENT_LIST_EXCERPT = 'CONTENT_LIST_EXCERPT',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452639
     */
    CONTENT_FIELDS = 'CONTENT_FIELDS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=75450718
     */
    CONTENT_LIST_LINK_OPEN_NEW_TAB = 'CONTENT_LIST_LINK_OPEN_NEW_TAB',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454247
     */
    WIDGET_TYPE_CONTENT_LIST_SOCIAL = 'WIDGET_TYPE_CONTENT-LIST_SOCIAL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=816392913
     */
    CUSTOMIZATIONS_WARNING = 'CUSTOMER_SETTINGS.PUBLIC_CUSTOMIZATIONS_WARNING',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454157
     */
    WIDGET_TYPE_CONTENT_FILTER_DATES = 'WIDGET_TYPE_CONTENT-FILTER_DATES',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454159
     */
    WIDGET_TYPE_CONTENT_FILTER_DIRECTORY_TAGS = 'WIDGET_TYPE_CONTENT-FILTER_DIRECTORY-TAGS',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452949
     */
    FILE_FIELDS = 'FILE_FIELDS',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453245
     */
    META_FIELDS = 'META_FIELDS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=816339467
     */
    CUSTOMIZATIONS = 'ADMIN.FEATURES.PUBLIC_JS_CUSTOMIZATIONS.NAME',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453246
     */
    META_SOCIAL_FIELDS = 'META_SOCIAL_FIELDS',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454489
     */
    WIDGET_TYPE_META_SOCIAL_COMMENT = 'WIDGET_TYPE_META-SOCIAL_COMMENT',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454491
     */
    WIDGET_TYPE_META_SOCIAL_FOLLOW = 'WIDGET_TYPE_META-SOCIAL_FOLLOW',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454492
     */
    WIDGET_TYPE_META_SOCIAL_LIKE = 'WIDGET_TYPE_META-SOCIAL_LIKE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452853
     */
    DIRECTORY_FILTERS = 'DIRECTORY_FILTERS',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453383
     */
    POST_FIELDS = 'POST_FIELDS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=11506028
     */
    CUSTOMIZATION = 'ADMIN.NAV.MOBILE_SETTINGS_CUSTOMIZATION',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454504
     */
    WIDGET_TYPE_POST_LIST_ATTACHMENTS = 'WIDGET_TYPE_POST-LIST_ATTACHMENTS',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=30496747
     */
    WIDGET_TYPE_POST_LIST_SHARED_IN_COMMUNITIES = 'WIDGET_TYPE_POST-LIST_SHAREDINCOMMUNITIES',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454508
     */
    WIDGET_TYPE_POST_LIST_DATES = 'WIDGET_TYPE_POST-LIST_DATES',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=31599228
     */
    SOCIAL_SETTINGS = 'SOCIAL_SETTINGS',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=31599356
     */
    SOCIAL_SETTINGS_MULTIPOSTING_ALLOWED = 'SOCIAL_SETTINGS_MULTIPOSTING_ALLOWED',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453740
     */
    USER_BLOCK_DEFAULT_FIELD = 'USER_BLOCK_DEFAULT_FIELD',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453741
     */
    USER_BLOCK_USER_DIRECTORY_FIELD = 'USER_BLOCK_USER_DIRECTORY_FIELD',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=8372307
     */
    WYSIWYG = 'ADVANCED.SETTINGS.WYSIWYG',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=56151356
     */
    WYSIWYG_PASTEPLAIN = 'WYSIWYG_PASTEPLAIN',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454612
     */
    WYSIWYG_TOOLBAR = 'WYSIWYG_TOOLBAR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=164453633
     */
    COMMENTS = 'REPORTS.COMMENT_RESOURCE_TYPE_FILTER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=72988595
     */
    BLOCK_XSS_HTML_TAGS = 'BLOCK_XSS_HTML_TAGS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=72988610
     */
    PLATFORM_SETTINGS_HTML_WHITELIST_ALL = 'PLATFORM_SETTINGS_HTML_WHITELIST_ALL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=72988683
     */
    PLATFORM_SETTINGS_HTML_WHITELIST_PLATFORM = 'PLATFORM_SETTINGS_HTML_WHITELIST_PLATFORM',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=72988723
     */
    PLATFORM_SETTINGS_HTML_WHITELIST_SITE = 'PLATFORM_SETTINGS_HTML_WHITELIST_SITE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=80494266
     */
    BETA_FEATURES = 'ADVANCED.SETTINGS.BETA_FEATURES',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452664
     */
    CONTENT_FILTERS = 'CONTENT_FILTERS',
}
